import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Plus, Pencil, Trash2 } from 'lucide-react';
import { portHooks } from '../../hooks/useMasters.js';
import Card from '../../components/ui/Card.jsx';
import Button from '../../components/ui/Button.jsx';
import Input from '../../components/ui/Input.jsx';
import Modal from '../../components/ui/Modal.jsx';

export default function PortsPage() {
  const { data: ports = [], isLoading } = portHooks.useList();
  const create = portHooks.useCreate();
  const update = portHooks.useUpdate();
  const del = portHooks.useDelete();

  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();

  const openCreate = () => { setEditing(null); reset({}); setModalOpen(true); };
  const openEdit = (p) => { setEditing(p); reset(p); setModalOpen(true); };

  const onSubmit = async (values) => {
    editing ? await update.mutateAsync({ id: editing.id, ...values }) : await create.mutateAsync(values);
    setModalOpen(false);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Ports</h2>
          <p className="text-sm text-gray-500">Export ports for finished product shipments</p>
        </div>
        <Button icon={Plus} onClick={openCreate}>Add Port</Button>
      </div>
      <Card>
        {isLoading ? <div className="p-8 text-center text-gray-400">Loading…</div> : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b">
              <tr>{['Port Name', 'Code', ''].map(h => (
                <th key={h} className="text-left px-4 py-3 font-medium text-gray-600 text-xs uppercase">{h}</th>
              ))}</tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {ports.map(p => (
                <tr key={p.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium">{p.name}</td>
                  <td className="px-4 py-3 font-mono text-gray-600">{p.code}</td>
                  <td className="px-4 py-3 text-right flex gap-2 justify-end">
                    <button onClick={() => openEdit(p)} className="text-gray-400 hover:text-teal-600"><Pencil className="w-4 h-4" /></button>
                    <button onClick={() => del.mutate(p.id)} className="text-gray-400 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
      <Modal open={modalOpen} onClose={() => setModalOpen(false)} title={editing ? 'Edit Port' : 'Add Port'}>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <Input label="Port Name" required placeholder="e.g. Kolkata, Vizag" {...register('name', { required: true })} error={errors.name && 'Required'} />
          <Input label="Port Code" required placeholder="e.g. KOL, VIZ" {...register('code', { required: true })} error={errors.code && 'Required'} />
          <div className="flex justify-end gap-3 pt-2">
            <Button variant="secondary" type="button" onClick={() => setModalOpen(false)}>Cancel</Button>
            <Button type="submit" loading={isSubmitting}>Save</Button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
